/**
 * Loads Leaflet CSS by dynamically creating and appending a link element to the document head
 * 
 * @function loadLeafletCSS
 * @returns {void}
 */
export const loadLeafletCSS = () => {
  const linkElement = document.createElement('link');
  linkElement.rel = 'stylesheet';
  linkElement.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
  linkElement.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';
  linkElement.crossOrigin = '';
  document.head.appendChild(linkElement);
};

/**
 * Loads Leaflet JavaScript by dynamically creating and appending a script element to the document head
 * 
 * @function loadLeafletJS
 * @param {Function} onLoadCallback - Callback function to execute after Leaflet JS is loaded
 * @returns {void}
 */
export const loadLeafletJS = (onLoadCallback) => {
  const scriptElement = document.createElement('script');
  scriptElement.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
  scriptElement.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
  scriptElement.crossOrigin = '';
  scriptElement.onload = onLoadCallback;
  document.head.appendChild(scriptElement);
};

/**
 * Adds an OpenStreetMap tile layer to the provided Leaflet map instance
 * 
 * @function addTileLayer
 * @param {Object} map - Leaflet map instance to add the tile layer to
 * @returns {Object} The added tile layer instance
 */
export const addTileLayer = (map) => {

  return window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { 
    noWrap: true,
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  }).addTo(map);
};

/**
 * Ensures Leaflet is loaded before executing the provided callback function
 * If Leaflet is already loaded, executes the callback immediately
 * Otherwise, loads Leaflet CSS and JS before executing the callback
 * 
 * @function loadLeaflet
 * @param {Function} callbackAfterLeafletLoad - Function to execute after Leaflet is loaded
 * @returns {void}
 */
export const loadLeaflet = (callbackAfterLeafletLoad) => {
  if (window.L) {
    callbackAfterLeafletLoad();
    return;
  }

  loadLeafletCSS();
  loadLeafletJS(callbackAfterLeafletLoad);
};

